



import React, { useEffect, useState } from "react";
import axios from "axios";
import { fetchUserFromRedis } from "../AuthonticationPages/Register";
import { useNavigate } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
const API = process.env.REACT_APP_API_BASE_URL;
const SIDEBAR_WIDTH = 280; // must match DRAWER_WIDTH in Header.jsx

const TIME_SLOTS = [
  "7:00 AM – 9:00 AM",
  "9:00 AM – 11:00 AM",
  "11:00 AM – 1:00 PM",
  "2:00 PM – 4:00 PM",
  "4:00 PM – 6:00 PM",
];

// ─── Package Card ──────────────────────────────────────────────────────────────
const PackageCard = ({ pkg, onBook }) => {
  const [expanded, setExpanded] = useState(false);
  const savings = pkg.total - pkg.offerPrice;
  const discountPct = Math.round((savings / pkg.total) * 100);
  const preview = pkg.tests.slice(0, expanded ? pkg.tests.length : 4);

  return (
    <div className="pkg-card">
      {/* Coloured header */}
      <div className="pkg-card-header" style={{ background: pkg.gradient }}>
        <div className="pkg-card-orb o1" />
        <div className="pkg-card-orb o2" />
        <div className="pkg-card-top-row">
          <span className="pkg-tier-badge" style={{ background: pkg.badgeBg, color: pkg.badgeColor }}>
            {pkg.icon} {pkg.tier}
          </span>
          <span className="pkg-disc-chip">{discountPct}% OFF</span>
        </div>
        <h3 className="pkg-card-name">{pkg.name}</h3>
        <p className="pkg-card-tagline">{pkg.tagline}</p>
        <div className="pkg-price-row">
          <span className="pkg-offer-price" style={{ color: pkg.accentColor }}>
            ₹{pkg.offerPrice.toLocaleString()}
          </span>
          <span className="pkg-mrp">₹{pkg.total.toLocaleString()}</span>
          <span className="pkg-save-chip">Save ₹{savings.toLocaleString()}</span>
        </div>
      </div>

      {/* Body */}
      <div className="pkg-card-body">
        <div className="pkg-tests-hdr">
          <span className="pkg-tests-lbl">🔬 Included Tests</span>
          <span className="pkg-tests-cnt" style={{ background: pkg.badgeBg, color: pkg.badgeColor }}>
            {pkg.tests.length}
          </span>
        </div>

        <div className="pkg-tests-list">
          {preview.map((t, i) => (
            <div key={i} className="pkg-test-row">
              <span className="pkg-test-dot" style={{ background: pkg.badgeColor }} />
              <span className="pkg-test-name">
                {t.name.length > 50 ? t.name.slice(0, 50) + "…" : t.name}
              </span>
            </div>
          ))}
        </div>

        {pkg.tests.length > 4 && (
          <button className="pkg-expand-btn" style={{ color: pkg.badgeColor }}
            onClick={() => setExpanded(!expanded)}>
            {expanded ? "▲ Show less" : `▼ +${pkg.tests.length - 4} more tests`}
          </button>
        )}

        {/* Footer pinned to bottom */}
        <div className="pkg-card-footer">
          <div className="pkg-footer-price">
            <span className="pkg-footer-lbl">Offer Price</span>
            <span className="pkg-footer-val" style={{ color: pkg.badgeColor }}>
              ₹{pkg.offerPrice.toLocaleString()}
            </span>
          </div>
          <button className="pkg-book-btn" style={{ background: pkg.gradient }}
            onClick={() => onBook(pkg)}>
            Book Now →
          </button>
        </div>
      </div>
    </div>
  );
};

// ─── Booking Modal ─────────────────────────────────────────────────────────────
const BookingModal = ({ pkg, onClose }) => {
  const [step, setStep] = useState(1);
  const [form, setForm] = useState({
    patient_name: "", phone: "", email: "", age: "",
    gender: "", address: "", pincode: "",
    preferred_date: "", preferred_time: "", notes: "",
  });
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(null);
  const [error, setError] = useState("");
  const [prefillLoaded, setPrefillLoaded] = useState(false);
  const [razorpayLoaded, setRazorpayLoaded] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("cash");
  const [bookingId,setBookingId] =useState("")


  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);

  useEffect(() => {
    if (window.Razorpay) { setRazorpayLoaded(true); return; }
    const s = document.createElement("script");
    s.src = process.env.REACT_APP_RAZORPAY_SCRIPT;
    s.async = true;
    s.onload = () => setRazorpayLoaded(true);
    s.onerror = () => setError("Failed to load payment gateway.");
    document.body.appendChild(s);
  }, []);
    const handleInvoiceCreation=async(payload,booking_id)=>{
      try{
            const invoice_response = await axios.post(
              `${process.env.REACT_APP_API_INVOICE}/invoice/pos_invoice`,
              payload,
            );
      
          const invoice = invoice_response.data.invoice_details;
          if (invoice.storage_type === "s3") {
            // Open CloudFront URL
            window.open(invoice.cloudfront_url, "_blank");
          } else if (invoice.storage_type === "local") {
            try {
            const token = sessionStorage.getItem("token");

            const response = await axios.get(
              `${process.env.REACT_APP_API_INVOICE}/package-invoice/download/${booking_id}`,
              {
                responseType: "blob",
                headers: {
                  Authorization: `Bearer ${token}`,
                },
              }
            );

            const blob = new Blob([response.data], { type: "application/pdf" });
            const url = window.URL.createObjectURL(blob);

            window.open(url, "_blank");

          } catch (error) {
            console.error("Invoice download failed:", error);
          }
          }

        }
        catch (error) {
            console.error("Invoice upload failed:", error);
          }
    }

  useEffect(() => {
    if (!pkg) return;
    (async () => {
      try {
        const userId = sessionStorage.getItem("userId");
        const token  = sessionStorage.getItem("token");
        if (userId && token) {
          const user = await fetchUserFromRedis(userId, token);
          if (user) {
            setForm(f => ({
              ...f,
              patient_name: user.name || user.full_name || "",
              phone:  user.phone  || user.mobile || "",
              email:  user.email  || "",
              age:    user.age ? String(user.age) : "",
              gender: user.gender || "",
              address: user.address?.address_line2 || "",
              pincode: user.address?.pincode || user.zip_code || "",
            }));
            setPrefillLoaded(true);
            return;
          }
        }
        const saved = sessionStorage.getItem("patient_prefill");
        if (saved) { setForm(f => ({ ...f, ...JSON.parse(saved) })); setPrefillLoaded(true); }
      } catch (e) { console.error(e); }
    })();
  }, [pkg]);

  if (!pkg) return null;
  const savings = pkg.total - pkg.offerPrice;
  const discountPct = Math.round((savings / pkg.total) * 100);
  const ch = e => setForm({ ...form, [e.target.name]: e.target.value });

  const validateStep = s => {
    if (s === 1) {
      if (!form.patient_name.trim()) { setError("Full Name is required"); return false; }
      if (!form.phone.trim())        { setError("Phone Number is required"); return false; }
    }
    if (s === 2) {
      if (!form.preferred_date) { setError("Please select a Preferred Date"); return false; }
      if (!form.preferred_time) { setError("Please select a Time Slot"); return false; }
    }
    setError(""); return true;
  };

  const next = () => { if (validateStep(step)) setStep(s => Math.min(s + 1, 3)); };
  const back = () => { setError(""); setStep(s => Math.max(s - 1, 1)); };

  const submit = async () => {
    setError(""); setLoading(true);
    const savePrefill = () => localStorage.setItem("patient_prefill", JSON.stringify({
      patient_name: form.patient_name, phone: form.phone, email: form.email,
      age: form.age, gender: form.gender, address: form.address, pincode: form.pincode,
    }));

    if (paymentMethod === "cash") {
      try {
        const res = await axios.post(`${API}/package-orders/create`, {
          package_id: pkg.id, package_name: pkg.name, mrp: pkg.total,
          payment_method: "cash", ...form, age: form.age ? parseInt(form.age) : null,
        });
        savePrefill();
        setSuccess(res.data.booking);
const community_name=sessionStorage.getItem('user')
    const community=JSON.parse(community_name).address.community_name
          setBookingId(res.data.booking.booking_ref)
          const packageBookingData={
          service_type:"package",
          order_id: res.data.booking.booking_ref,
          items: pkg.name,
          patient_details: form,
          subtotal: pkg.total,
          discount:  savings,
          community_name:community,
          total_amount: pkg.total-savings,
          payment: { method: paymentMethod },
          created_at: new Date().toISOString()
        }
        console.log(packageBookingData)
        handleInvoiceCreation(packageBookingData,res.data.booking.booking_ref)
      } catch (err) { setError(err.response?.data?.error || "Booking failed. Please try again."); }
      setLoading(false); return;
    }

    if (!razorpayLoaded || !window.Razorpay) {
      setError("Payment gateway is loading. Please try again.");
      setLoading(false); return;
    }
    try {
      const orderRes = await axios.post(process.env.REACT_APP_CREATE_RAZORPAY_ORDER, {
        amount: pkg.offerPrice, currency: "INR", receipt: `pkg_${Date.now()}`,
        notes: { order_type: "package_booking", package_id: pkg.id, package_name: pkg.name, patient_name: form.patient_name, phone: form.phone },
        service_type:"package",
          customer_name:form.patient_name,
          contact: form.phone,
      });
      if (!orderRes.data?.id) throw new Error("Failed to create payment order");
      setLoading(false);
      setBookingId(orderRes.data.id)
      const rzp = new window.Razorpay({
        key: process.env.REACT_APP_RAZORPAY_KEY, currency: "INR",
        name: "Ayuja Life Services", description: pkg.name,
        order_id: orderRes.data.id,
        prefill: { name: form.patient_name, email: form.email, contact: form.phone },
        theme: { color: pkg.accentColor || "#006D77" },
        handler: async ps => {
          setLoading(true);
          try {
            const vr = await axios.post(process.env.REACT_APP_PROCESS_PAYEMENT, {
              razorpay_payment_id: ps.razorpay_payment_id,
              razorpay_order_id:   ps.razorpay_order_id,
              razorpay_signature:  ps.razorpay_signature,
            });
            if (vr.data?.status !== "success") throw new Error("Payment verification failed");
            const cr = await axios.post(`${API}/package-orders/confirm-payment`, {
              razorpay_order_id:   ps.razorpay_order_id,
              razorpay_payment_id: ps.razorpay_payment_id,
              razorpay_signature:  ps.razorpay_signature,
              package_id: pkg.id, package_name: pkg.name, mrp: pkg.total,
              ...form, age: form.age ? parseInt(form.age) : null,
            });
            savePrefill();
            setSuccess(cr.data.booking);
        const packageBookingData={
          service_type:"package",
          order_id: bookingId,
          items: pkg.name,
          patient_details: form,
          subtotal: pkg.total,
          discount:  savings,
          total_amount: pkg.total-savings,
          payment: { method: paymentMethod },
          created_at: new Date().toISOString()
        }
        handleInvoiceCreation(packageBookingData,orderRes.data.id)

          } catch (err) {
            setError("Payment received but booking failed. Contact support with Payment ID: " + ps.razorpay_payment_id);
          }
          setLoading(false);
        },
        modal: { ondismiss: () => { setLoading(false); setError("Payment cancelled."); } },
      });
      rzp.on("payment.failed", r => { setLoading(false); setError(`Payment failed: ${r.error.description}`); });
      rzp.open();
    } catch (err) {
      setError(err.response?.data?.detail || err.message || "Could not initiate payment.");
      setLoading(false);
    }
  };

  const STEPS = ["Patient", "Schedule", "Payment"];

  if (success) return (
    <div className="mo-overlay" onClick={onClose}>
      <div className="mo-box" onClick={e => e.stopPropagation()}>
        <div className="mo-hero" style={{ background: pkg.gradient }}>
          <div className="mo-orb1" /><div className="mo-orb2" />
          <div className="success-wrap">
            <div className="success-icon">✅</div>
            <h2 className="success-title">Booking Confirmed!</h2>
            <p className="success-sub">Your slot has been reserved successfully.</p>
            <div className="success-ref">
              <span className="success-ref-lbl">Booking Reference</span>
              <div className="success-ref-val">{success.booking_ref}</div>
            </div>
          </div>
        </div>
        <div className="success-body">
          <div className="success-grid">
            {[
              ["👤 Patient",  success.patient_name],
              ["📦 Package",  success.package_name],
              ["💰 Paid",     `₹${success.offer_price?.toLocaleString()}`],
              ["🎉 Savings",  `₹${success.savings?.toLocaleString()}`],
              ["📅 Date",     success.preferred_date],
              ["🕐 Time",     success.preferred_time],
              ["💳 Payment",  success.payment_method === "online" ? "Paid Online" : "Cash on Completion"],
              ["📋 Status",   success.status],
            ].map(([l, v]) => (
              <div key={l} className="success-item">
                <span className="si-label">{l}</span>
                <span className="si-value">{v}</span>
              </div>
            ))}
          </div>
          <p className="success-note">Our team will call you to confirm your appointment. Save your booking reference!</p>
          <button className="mo-primary-btn" style={{ background: pkg.gradient }} onClick={onClose}>Done ✓</button>
        </div>
      </div>
    </div>
  );

  return (
    <div className="mo-overlay" onClick={onClose}>
      <div className="mo-box" onClick={e => e.stopPropagation()}>
        {/* Header */}
        <div className="mo-hero" style={{ background: pkg.gradient }}>
          <div className="mo-orb1" /><div className="mo-orb2" />
          <button className="mo-close" onClick={onClose}>✕</button>
          <div className="mo-hero-inner">
            <span className="mo-pkg-icon">{pkg.icon}</span>
            <div className="mo-pkg-info">
              <div className="mo-pkg-tier" style={{ color: pkg.accentColor }}>{pkg.tier}</div>
              <h2 className="mo-pkg-name">Book {pkg.name}</h2>
              <div className="mo-pkg-pricing">
                <span className="mo-offer" style={{ color: pkg.accentColor }}>₹{pkg.offerPrice.toLocaleString()}</span>
                <span className="mo-strike">₹{pkg.total.toLocaleString()}</span>
                <span className="mo-save-chip">{discountPct}% OFF · Save ₹{savings.toLocaleString()}</span>
              </div>
            </div>
          </div>
        </div>

        {/* Step bar */}
        <div className="step-bar">
          {STEPS.map((lbl, i) => (
            <React.Fragment key={i}>
              <div className="step-item">
                <div className="step-circle"
                  style={step > i + 1 ? { background: pkg.accentColor, borderColor: pkg.accentColor, color: "#fff" }
                    : step === i + 1 ? { borderColor: pkg.accentColor, color: pkg.accentColor } : {}}>
                  {step > i + 1 ? "✓" : i + 1}
                </div>
                <span className="step-lbl" style={step === i + 1 ? { color: pkg.accentColor, fontWeight: 700 } : {}}>{lbl}</span>
              </div>
              {i < STEPS.length - 1 && (
                <div className="step-line" style={{ background: step > i + 1 ? pkg.accentColor : "#E2E8F0" }} />
              )}
            </React.Fragment>
          ))}
        </div>

        {/* Form body */}
        <div className="mo-body">
          {prefillLoaded && form.patient_name && (
            <div className="prefill-bar">
              <span>✅ Details prefilled from your profile</span>
              <button onClick={() => { setForm(f => ({ ...f, patient_name: "", phone: "", email: "", age: "", gender: "", address: "", pincode: "" })); setPrefillLoaded(false); }}>Clear</button>
            </div>
          )}

          {step === 1 && (
            <div className="form-sec">
              <h3 className="form-sec-title">👤 Patient Details</h3>
              <div className="form-grid">
                <div className="fg full"><label className="fl">Full Name *</label><input className="fi" name="patient_name" placeholder="Enter patient's full name" value={form.patient_name} onChange={ch} /></div>
                <div className="fg"><label className="fl">Phone *</label><input className="fi" name="phone" placeholder="+91 XXXXX XXXXX" value={form.phone} onChange={ch} /></div>
                <div className="fg"><label className="fl">Email</label><input className="fi" name="email" placeholder="email@example.com" value={form.email} onChange={ch} /></div>
                <div className="fg"><label className="fl">Age</label><input className="fi" name="age" type="number" placeholder="Age" value={form.age} onChange={ch} /></div>
                <div className="fg"><label className="fl">Gender</label><select className="fi" name="gender" value={form.gender} onChange={ch}><option value="">Select</option><option>Male</option><option>Female</option><option>Other</option></select></div>
                <div className="fg"><label className="fl">Pincode</label><input className="fi" name="pincode" placeholder="6-digit pincode" value={form.pincode} onChange={ch} /></div>
                <div className="fg full"><label className="fl">Collection Address</label><textarea className="fi ft" name="address" placeholder="Full address for sample collection" value={form.address} onChange={ch} /></div>
              </div>
            </div>
          )}

          {step === 2 && (
            <div className="form-sec">
              <h3 className="form-sec-title">📅 Preferred Schedule</h3>
              <div className="form-grid">
                <div className="fg"><label className="fl">Preferred Date *</label><input className="fi" name="preferred_date" type="date" value={form.preferred_date} min={new Date().toISOString().split("T")[0]} onChange={ch} /></div>
                <div className="fg"><label className="fl">Time Slot *</label><select className="fi" name="preferred_time" value={form.preferred_time} onChange={ch}><option value="">Select slot</option>{TIME_SLOTS.map(t => <option key={t}>{t}</option>)}</select></div>
                <div className="fg full"><label className="fl">Special Notes</label><textarea className="fi ft" name="notes" placeholder="Any special health conditions or instructions for our team..." value={form.notes} onChange={ch} /></div>
              </div>
              <div className="sch-chips">
                {["🏠 Home collection", "⚡ Results in 24–48 hrs", "🔬 NABL certified"].map(c => (
                  <span key={c} className="sch-chip">{c}</span>
                ))}
              </div>
            </div>
          )}

          {step === 3 && (
            <div className="form-sec">
              <h3 className="form-sec-title">💳 Payment</h3>
              <div className="order-summary" style={{ borderColor: pkg.accentColor + "44" }}>
                <div className="order-hdr" style={{ background: pkg.gradient }}>
                  <div className="order-orb" />
                  <span className="order-hdr-title">📋 Order Summary</span>
                </div>
                {[
                  ["Package",         pkg.name],
                  ["Tests",           `${pkg.tests.length} included`],
                  ["MRP",             <s style={{ color: "#94A3B8" }}>₹{pkg.total.toLocaleString()}</s>],
                  ["Discount",        <span style={{ color: "#10B981" }}>- ₹{savings.toLocaleString()} ({discountPct}%)</span>],
                  ["Date",            form.preferred_date],
                  ["Time",            form.preferred_time],
                  ["Patient",         form.patient_name],
                ].map(([l, v], i) => (
                  <div key={i} className="order-row"><span className="order-lbl">{l}</span><span className="order-val">{v}</span></div>
                ))}
                <div className="order-row order-total">
                  <span>Total Payable</span>
                  <span className="order-total-val" style={{ color: pkg.accentColor }}>₹{pkg.offerPrice.toLocaleString()}</span>
                </div>
              </div>

              <p className="payment-title">Choose Payment Method</p>
              <div className="pay-opts">
                {[
                  { id: "cash",   icon: "💵", label: "Cash on Completion", sub: "Pay our team after sample collection at home" },
                  { id: "online", icon: "💳", label: "Pay Online Now",      sub: "Secure instant payment via Razorpay" },
                ].map(o => (
                  <div key={o.id} className={`pay-opt ${paymentMethod === o.id ? "pay-opt-on" : ""}`}
                    style={paymentMethod === o.id ? { borderColor: pkg.accentColor, background: pkg.accentColor + "10" } : {}}
                    onClick={() => setPaymentMethod(o.id)}>
                    <span className="pay-opt-icon">{o.icon}</span>
                    <div className="pay-opt-info">
                      <div className="pay-opt-lbl" style={paymentMethod === o.id ? { color: pkg.accentColor } : {}}>{o.label}</div>
                      <div className="pay-opt-sub">{o.sub}</div>
                    </div>
                    <div className="pay-radio" style={paymentMethod === o.id ? { borderColor: pkg.accentColor, background: pkg.accentColor, color: "#fff" } : {}}>
                      {paymentMethod === o.id && "✓"}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}

          {error && <div className="form-error">⚠️ {error}</div>}

          <div className="mo-nav">
            {step > 1 && <button className="mo-back-btn" onClick={back}>← Back</button>}
            {step < 3
              ? <button className="mo-next-btn" style={{ background: pkg.gradient }} onClick={next}>Continue →</button>
              : <button className="mo-primary-btn"
                  style={{ background: pkg.gradient, opacity: loading || (paymentMethod === "online" && !razorpayLoaded) ? 0.7 : 1 }}
                  onClick={submit} disabled={loading || (paymentMethod === "online" && !razorpayLoaded)}>
                  {loading ? "⏳ Processing..."
                    : paymentMethod === "cash" ? `✅ Confirm — ₹${pkg.offerPrice.toLocaleString()} Cash`
                    : !razorpayLoaded ? "⏳ Loading..."
                    : `💳 Pay ₹${pkg.offerPrice.toLocaleString()} Securely`}
                </button>
            }
          </div>
        </div>
      </div>
    </div>
  );
};

// ─── Main Page ─────────────────────────────────────────────────────────────────
const MyPackageBookings = () => {
  const [packages,    setPackages]    = useState([]);
  const [loading,     setLoading]     = useState(true);
  const [bookingPkg,  setBookingPkg]  = useState(null);
  const [search,      setSearch]      = useState("");
  const [selTier,     setSelTier]     = useState("All");
  const navigate = useNavigate();
  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const res  = await fetch(`${API}/health-camp/packages`);
        const data = await res.json();
        if (data.success) setPackages(data.packages || []);
      } catch (err) { console.error(err); }
      finally { setLoading(false); }
    })();
  }, []);

  const tiers    = ["All", ...Array.from(new Set(packages.map(p => p.tier)))];
  const filtered = packages
    .filter(p => selTier === "All" || p.tier === selTier)
    .filter(p => !search || p.name.toLowerCase().includes(search.toLowerCase()) || p.tagline?.toLowerCase().includes(search.toLowerCase()))
    .reverse();

  return (
    <>
      <style>{CSS}</style>
      <div className="page-root">
 
        {/* Banner */}
        <div className="page-banner">
  
          <div className="banner-orb1" /><div className="banner-orb2" />
          <div className="back-button" onClick={() => navigate(-1)}>
            <ArrowBackIcon />
        </div>
          <div className="banner-inner">
            <div className="banner-text">
            <span className="banner-eyebrow"></span>
              {/* <span className="banner-eyebrow">🏥 Ayuja Health Care</span> */}
              <h1 className="banner-title">Health Packages</h1>
              <p className="banner-sub">Curated diagnostic bundles with home sample collection — comprehensive care at best value.</p>
              <div className="banner-tags">
                {["🏠 Home Collection", "⚡ Fast Results", "🔬 NABL Certified"].map(t => (
                  <span key={t} className="banner-tag">{t}</span>
                ))}
              </div>
            </div>
            {!loading && (
              <div className="banner-stat">
                <div className="stat-num">{packages.length}</div>
                <div className="stat-lbl">Packages Available</div>
              </div>
            )}
          </div>
        </div>

        {/* Search + filter — sticky */}
        <div className="controls-bar">
          <div className="controls-inner">
            <div className="search-wrap">
              <span>🔍</span>
              <input className="search-inp" placeholder="Search packages..."
                value={search} onChange={e => setSearch(e.target.value)} />
              {search && <button className="search-clr" onClick={() => setSearch("")}>✕</button>}
            </div>
            <div className="tier-row">
              {tiers.map(t => (
                <button key={t} className={`tier-btn ${selTier === t ? "tier-active" : ""}`}
                  onClick={() => setSelTier(t)}>{t}</button>
              ))}
            </div>
          </div>
        </div>

        {/* Content */}
        <div className="page-body">
          {loading ? (
            <div className="state-center">
              <div className="spinner" />
              <p>Loading health packages…</p>
            </div>
          ) : filtered.length === 0 ? (
            <div className="state-center">
              <span style={{ fontSize: 52 }}>📦</span>
              <h3>{search || selTier !== "All" ? "No packages match your filter" : "No Packages Available"}</h3>
              <p>{search || selTier !== "All" ? "Try a different search or category" : "Check back soon!"}</p>
              {(search || selTier !== "All") && (
                <button className="clear-btn" onClick={() => { setSearch(""); setSelTier("All"); }}>Clear Filters</button>
              )}
            </div>
          ) : (
            <>
              <p className="results-lbl">
                Showing <strong>{filtered.length}</strong> package{filtered.length !== 1 ? "s" : ""}
                {selTier !== "All" && <> in <strong>{selTier}</strong></>}
                {search && <> matching "<strong>{search}</strong>"</>}
              </p>
              <div className="pkg-grid">
                {filtered.map(pkg => (
                  <PackageCard key={pkg.id} pkg={pkg} onBook={setBookingPkg} />
                ))}
              </div>
            </>
          )}
        </div>
      </div>

      {bookingPkg && <BookingModal pkg={bookingPkg} onClose={() => setBookingPkg(null)} />}
    </>
  );
};

export default MyPackageBookings;

// ─── Styles ────────────────────────────────────────────────────────────────────
const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@700;800;900&family=Nunito:wght@400;500;600;700;800&display=swap');

  /* ── Reset scoped to our page ── */
  .page-root *, .page-root *::before, .page-root *::after { box-sizing: border-box; margin: 0; padding: 0; }

  .page-root {
    /* Desktop: offset by sidebar width so content starts after the sidebar */
    margin-left: 280px;
    width: calc(100% - 280px);
    overflow-x: hidden;
    min-height: 100vh;
    background: #EEF4F5;
    font-family: 'Nunito', sans-serif;
    color: #0F172A;
  }

  /* On mobile (≤ 899px) the sidebar is hidden, so remove the offset */
  @media (max-width: 899px) {
    .page-root {
      margin-left: 0;
      width: 100%;
    }
  }

  /* ── Banner ── */
  .page-banner {
    background: linear-gradient(135deg, #003D45 0%, #006D77 55%, #008B98 100%);
    padding: clamp(1px, 4vw, 24px) clamp(6px, 3vw, 40px);
    position: relative;
    overflow: hidden;
  }
  .banner-orb1 { position:absolute; top:-70px; right:-50px; width:clamp(180px,25vw,300px); height:clamp(180px,25vw,300px); border-radius:50%; background:rgba(255,255,255,0.07); pointer-events:none; }
  .banner-orb2 { position:absolute; bottom:-40px; left:3%; width:clamp(120px,15vw,200px); height:clamp(120px,15vw,200px); border-radius:50%; background:rgba(255,255,255,0.05); pointer-events:none; }
  .banner-inner { display:flex; justify-content:space-between; align-items:center; gap:20px; position:relative; z-index:1; flex-wrap:wrap; }
  .banner-text { flex:1; min-width:0; }
  .banner-eyebrow { display:inline-block; font-size:clamp(10px,1.4vw,12px); font-weight:700; color:rgba(255,255,255,0.65); letter-spacing:1.2px;  padding:4px 13px; border-radius:50px; margin-bottom:9px; }
  .banner-title { font-family:'Sora',sans-serif; font-size:clamp(1.6rem,4.5vw,2.8rem); font-weight:900; color:#fff; line-height:1.15; margin-bottom:8px; }
  .banner-sub { font-size:clamp(12px,1.8vw,15px); color:rgba(255,255,255,0.72); line-height:1.7; max-width:520px; margin-bottom:14px; }
  .banner-tags { display:flex; gap:8px; flex-wrap:wrap; }
  .banner-tag { font-size:clamp(10px,1.3vw,12px); font-weight:600; color:rgba(255,255,255,0.85); background:rgba(255,255,255,0.1); border:1px solid rgba(255,255,255,0.2); padding:4px 11px; border-radius:50px; }
  .banner-stat { background:rgba(255,255,255,0.13); border:1px solid rgba(255,255,255,0.22); border-radius:18px; padding:clamp(14px,2.5vw,22px) clamp(20px,3.5vw,36px); text-align:center; flex-shrink:0; }
  .stat-num { font-family:'Sora',sans-serif; font-size:clamp(2rem,5vw,3.2rem); font-weight:900; color:#80ED99; line-height:1; }
  .stat-lbl { font-size:clamp(11px,1.4vw,13px); color:rgba(255,255,255,0.65); font-weight:600; margin-top:4px; }

  /* ── Controls bar ── */
  .controls-bar { background:#fff; box-shadow:0 2px 10px rgba(0,0,0,0.07); position:sticky; top:0; z-index:40; }
  .controls-inner { padding:11px clamp(16px,3vw,40px); display:flex; gap:10px; align-items:center; flex-wrap:wrap; }
  .search-wrap { flex:1; min-width:min(200px,100%); display:flex; align-items:center; gap:8px; background:#F8FAFC; border:1.5px solid #E2E8F0; border-radius:10px; padding:0 12px; transition:border-color 0.2s; }
  .search-wrap:focus-within { border-color:#006D77; box-shadow:0 0 0 3px rgba(0,109,119,0.1); }
  .search-inp { flex:1; border:none; background:transparent; padding:9px 0; font-size:14px; font-family:'Nunito',sans-serif; color:#0F172A; outline:none; }
  .search-inp::placeholder { color:#94A3B8; }
  .search-clr { background:none; border:none; cursor:pointer; color:#94A3B8; font-size:13px; flex-shrink:0; }
  .tier-row { display:flex; gap:7px; flex-wrap:wrap; }
  .tier-btn { background:#F8FAFC; border:1.5px solid #E2E8F0; border-radius:50px; padding:6px clamp(10px,1.8vw,16px); font-size:clamp(11px,1.4vw,13px); font-weight:700; cursor:pointer; transition:all 0.18s; font-family:'Nunito',sans-serif; color:#64748B; white-space:nowrap; }
  .tier-btn:hover { border-color:#006D77; color:#006D77; }
  .tier-active { background:#006D77 !important; border-color:#006D77 !important; color:#fff !important; box-shadow:0 3px 10px rgba(0,109,119,0.28); }

  /* ── Page body ── */
  .page-body { padding: clamp(18px,3vw,36px) clamp(16px,3vw,40px) clamp(36px,5vw,72px); }
  .results-lbl { font-size:13px; color:#64748B; margin-bottom:18px; font-weight:500; }
  .results-lbl strong { color:#0F172A; }


  .pkg-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: clamp(14px, 2.2vw, 24px);
    align-items: stretch;
  }

  @media (max-width: 900px) {
    .pkg-grid {
      grid-template-columns: repeat(2, 1fr);
    }
  }

  @media (max-width: 580px) {
    .pkg-grid {
      grid-template-columns: 1fr;
    }
  }

  .pkg-card {
    background: #fff;
    border-radius: 20px;
    overflow: hidden;
    box-shadow: 0 3px 14px rgba(0,0,0,0.07);
    display: flex;
    flex-direction: column;
    height: 100%;
    transition: transform 0.22s ease, box-shadow 0.22s ease;
  }
  .pkg-card:hover { transform:translateY(-5px); box-shadow:0 18px 44px rgba(0,0,0,0.13); }

  .pkg-card-header { padding:clamp(16px,2.5vw,22px); position:relative; overflow:hidden; flex-shrink:0; }
  .pkg-card-orb { position:absolute; border-radius:50%; pointer-events:none; }
  .o1 { top:-38px; right:-38px; width:125px; height:125px; background:rgba(255,255,255,0.10); }
  .o2 { bottom:-22px; left:-18px; width:80px;  height:80px;  background:rgba(255,255,255,0.07); }

  .pkg-card-top-row { display:flex; justify-content:space-between; align-items:center; margin-bottom:10px; position:relative; z-index:1; }
  .pkg-tier-badge { font-size:clamp(10px,1.4vw,12px); font-weight:800; padding:4px 11px; border-radius:50px; }
  .pkg-disc-chip  { background:#10B981; color:#fff; font-size:11px; font-weight:800; padding:4px 9px; border-radius:20px; }

  .pkg-card-name    { font-family:'Sora',sans-serif; font-size:clamp(14px,2.2vw,17px); font-weight:800; color:#fff; margin-bottom:4px; position:relative; z-index:1; line-height:1.3; }
  .pkg-card-tagline { font-size:clamp(11px,1.5vw,13px); color:rgba(255,255,255,0.72); line-height:1.6; margin-bottom:12px; position:relative; z-index:1; }

  .pkg-price-row { display:flex; align-items:center; gap:9px; flex-wrap:wrap; position:relative; z-index:1; }
  .pkg-offer-price { font-family:'Sora',sans-serif; font-size:clamp(19px,2.8vw,25px); font-weight:900; }
  .pkg-mrp       { font-size:13px; color:rgba(255,255,255,0.5); text-decoration:line-through; font-weight:600; }
  .pkg-save-chip  { background:rgba(16,185,129,0.25); border:1px solid rgba(16,185,129,0.5); color:#80ED99; font-size:11px; font-weight:800; padding:3px 9px; border-radius:20px; }

  /* card body: flex:1 takes remaining vertical space, footer stays at bottom */
  .pkg-card-body { padding:clamp(14px,2.5vw,20px); flex:1; display:flex; flex-direction:column; }

  .pkg-tests-hdr { display:flex; align-items:center; gap:7px; margin-bottom:10px; }
  .pkg-tests-lbl { font-size:11px; font-weight:700; color:#64748B; text-transform:uppercase; letter-spacing:0.5px; }
  .pkg-tests-cnt { font-size:11px; font-weight:800; padding:2px 7px; border-radius:50px; }

  /* flex:1 pushes footer down */
  .pkg-tests-list { flex:1; }
  .pkg-test-row  { display:flex; align-items:flex-start; gap:8px; margin-bottom:6px; }
  .pkg-test-dot  { width:7px; height:7px; border-radius:50%; flex-shrink:0; margin-top:5px; }
  .pkg-test-name { font-size:clamp(12px,1.6vw,13px); color:#374151; line-height:1.55; }

  .pkg-expand-btn { background:none; border:none; cursor:pointer; font-size:12px; font-weight:700; padding:3px 0; margin:4px 0 10px; text-decoration:underline; font-family:'Nunito',sans-serif; }

  /* margin-top:auto pins footer to bottom of card */
  .pkg-card-footer { display:flex; justify-content:space-between; align-items:center; gap:10px; padding-top:12px; border-top:1px solid #F1F5F9; flex-wrap:wrap; margin-top:auto; }
  .pkg-footer-price { display:flex; flex-direction:column; gap:2px; }
  .pkg-footer-lbl { font-size:11px; color:#94A3B8; font-weight:600; }
  .pkg-footer-val { font-family:'Sora',sans-serif; font-size:clamp(16px,2.3vw,20px); font-weight:900; line-height:1; }
  .pkg-book-btn { border:none; border-radius:10px; padding:clamp(9px,1.6vw,12px) clamp(14px,2.2vw,20px); font-size:clamp(12px,1.6vw,14px); font-weight:800; color:#fff; cursor:pointer; white-space:nowrap; font-family:'Nunito',sans-serif; transition:filter 0.2s, transform 0.15s; box-shadow:0 3px 10px rgba(0,0,0,0.18); }
  .pkg-book-btn:hover { filter:brightness(1.1); transform:translateY(-2px); }

  /* ── States ── */
  .state-center { display:flex; flex-direction:column; align-items:center; justify-content:center; gap:14px; padding:80px 20px; text-align:center; color:#64748B; }
  .state-center h3 { font-family:'Sora',sans-serif; font-size:20px; font-weight:700; color:#0F172A; }
  .state-center p  { font-size:14px; }
  .spinner { width:42px; height:42px; border:4px solid #E2E8F0; border-top-color:#006D77; border-radius:50%; animation:spin 0.8s linear infinite; }
  @keyframes spin { to { transform:rotate(360deg); } }
  .clear-btn { background:#006D77; color:#fff; border:none; border-radius:50px; padding:10px 22px; font-size:14px; font-weight:700; cursor:pointer; font-family:'Nunito',sans-serif; margin-top:6px; }

  /* ── Modal ── */
  .mo-overlay { position:fixed; inset:0; background:rgba(0,0,0,0.65); z-index:9999; display:flex; align-items:center; justify-content:center; padding:16px; backdrop-filter:blur(6px); overflow-y:auto; }
  .mo-box { background:#fff; border-radius:24px; width:100%; max-width:600px; max-height:90vh; overflow-y:auto; box-shadow:0 28px 72px rgba(0,0,0,0.32); animation:mo-in 0.26s cubic-bezier(0.34,1.3,0.64,1); }
  .mo-box::-webkit-scrollbar { width:4px; }
  .mo-box::-webkit-scrollbar-thumb { background:#E2E8F0; border-radius:4px; }
  @keyframes mo-in { from{opacity:0;transform:translateY(14px) scale(0.97);} to{opacity:1;transform:none;} }

  .mo-hero { padding:clamp(18px,3.5vw,28px); position:relative; overflow:hidden; }
  .mo-orb1 { position:absolute; top:-45px; right:-45px; width:160px; height:160px; border-radius:50%; background:rgba(255,255,255,0.10); pointer-events:none; }
  .mo-orb2 { position:absolute; bottom:-28px; left:-18px; width:105px; height:105px; border-radius:50%; background:rgba(255,255,255,0.07); pointer-events:none; }
  .mo-close { position:absolute; top:12px; right:12px; background:rgba(255,255,255,0.2); border:none; color:#fff; width:30px; height:30px; border-radius:50%; cursor:pointer; font-size:13px; font-weight:700; display:flex; align-items:center; justify-content:center; z-index:2; }
  .mo-close:hover { background:rgba(255,255,255,0.35); }

  .mo-hero-inner { display:flex; align-items:flex-start; gap:14px; position:relative; z-index:1; }
  .mo-pkg-icon  { font-size:clamp(32px,5vw,44px); flex-shrink:0; }
  .mo-pkg-info  { flex:1; min-width:0; }
  .mo-pkg-tier  { font-size:11px; font-weight:800; text-transform:uppercase; letter-spacing:0.8px; margin-bottom:3px; }
  .mo-pkg-name  { font-family:'Sora',sans-serif; font-size:clamp(14px,2.8vw,18px); font-weight:800; color:#fff; margin-bottom:7px; line-height:1.25; }
  .mo-pkg-pricing { display:flex; align-items:center; gap:8px; flex-wrap:wrap; }
  .mo-offer     { font-family:'Sora',sans-serif; font-size:clamp(17px,3.5vw,22px); font-weight:900; }
  .mo-strike    { font-size:13px; color:rgba(255,255,255,0.5); text-decoration:line-through; font-weight:600; }
  .mo-save-chip { background:rgba(16,185,129,0.25); border:1px solid rgba(16,185,129,0.5); color:#80ED99; font-size:11px; font-weight:800; padding:3px 9px; border-radius:20px; }

  /* step bar */
  .step-bar { display:flex; align-items:center; justify-content:center; padding:14px 24px; border-bottom:1px solid #E2E8F0; }
  .step-item { display:flex; flex-direction:column; align-items:center; gap:4px; }
  .step-circle { width:30px; height:30px; border-radius:50%; border:2px solid #E2E8F0; display:flex; align-items:center; justify-content:center; font-size:12px; font-weight:800; color:#94A3B8; background:#fff; transition:all 0.25s; }
  .step-lbl { font-size:11px; font-weight:600; color:#94A3B8; white-space:nowrap; transition:color 0.25s; }
  .step-line { flex:1; height:2px; min-width:18px; max-width:54px; margin:0 6px; margin-bottom:18px; transition:background 0.25s; }

  /* modal body */
  .mo-body { padding:clamp(14px,3vw,22px) clamp(14px,3.5vw,24px) clamp(16px,3vw,24px); }

  .prefill-bar { display:flex; align-items:center; justify-content:space-between; gap:10px; background:#ECFDF5; border:1px solid #A7F3D0; border-radius:10px; padding:9px 13px; margin-bottom:14px; font-size:12px; color:#065F46; flex-wrap:wrap; }
  .prefill-bar button { background:none; border:none; font-size:12px; font-weight:700; color:#059669; cursor:pointer; font-family:'Nunito',sans-serif; }

  .form-sec { margin-bottom:4px; }
  .form-sec-title { font-size:14px; font-weight:800; color:#0F172A; margin-bottom:13px; padding-bottom:7px; border-bottom:2px solid #EEF8F9; }

  .form-grid { display:grid; grid-template-columns:repeat(auto-fit, minmax(min(100%,170px), 1fr)); gap:clamp(9px,1.8vw,12px); }
  .fg { display:flex; flex-direction:column; gap:5px; }
  .full { grid-column: 1 / -1; }
  .fl { font-size:11px; font-weight:700; color:#64748B; }
  .fi { border:1.5px solid #E2E8F0; border-radius:9px; padding:9px 11px; font-size:13px; color:#0F172A; font-family:'Nunito',sans-serif; outline:none; background:#F8FAFC; transition:border-color 0.2s; width:100%; }
  .fi:focus { border-color:#006D77; box-shadow:0 0 0 3px rgba(0,109,119,0.1); }
  .ft { height:72px; resize:vertical; }

  .sch-chips { display:flex; gap:8px; flex-wrap:wrap; margin-top:12px; }
  .sch-chip  { font-size:11px; font-weight:600; color:#006D77; background:#EEF8F9; border:1px solid rgba(0,109,119,0.2); padding:5px 11px; border-radius:50px; }

  /* order summary */
  .order-summary { border:1.5px solid; border-radius:14px; overflow:hidden; margin-bottom:16px; }
  .order-hdr { padding:10px 15px; display:flex; align-items:center; gap:10px; position:relative; overflow:hidden; }
  .order-orb { position:absolute; top:-28px; right:-28px; width:80px; height:80px; border-radius:50%; background:rgba(255,255,255,0.1); pointer-events:none; }
  .order-hdr-title { font-family:'Sora',sans-serif; font-size:13px; font-weight:800; color:#fff; position:relative; z-index:1; }
  .order-row { display:flex; justify-content:space-between; align-items:center; padding:9px 15px; border-bottom:1px solid #E2E8F0; font-size:12px; color:#64748B; gap:8px; }
  .order-row:last-child { border-bottom:none; }
  .order-lbl { flex-shrink:0; }
  .order-val { font-weight:700; color:#0F172A; text-align:right; max-width:55%; word-break:break-word; }
  .order-total { background:#EEF8F9; font-weight:700; font-size:13px; color:#0F172A; border-bottom:none; }
  .order-total-val { font-family:'Sora',sans-serif; font-size:18px; font-weight:900; }

  .payment-title { font-size:13px; font-weight:800; color:#0F172A; margin-bottom:10px; }
  .pay-opts { display:flex; flex-direction:column; gap:9px; }
  .pay-opt { display:flex; align-items:center; gap:12px; border:2px solid #E2E8F0; border-radius:13px; padding:13px 15px; cursor:pointer; transition:all 0.18s; background:#F8FAFC; }
  .pay-opt:hover { border-color:#006D77; }
  .pay-opt-icon  { font-size:24px; flex-shrink:0; }
  .pay-opt-info  { flex:1; min-width:0; }
  .pay-opt-lbl   { font-size:13px; font-weight:700; color:#0F172A; margin-bottom:2px; }
  .pay-opt-sub   { font-size:11px; color:#64748B; }
  .pay-radio { width:20px; height:20px; border-radius:50%; border:2px solid #E2E8F0; flex-shrink:0; display:flex; align-items:center; justify-content:center; font-size:10px; transition:all 0.18s; }

  .form-error { background:#FEF2F2; border:1.5px solid #FECACA; border-radius:9px; padding:10px 13px; font-size:12px; color:#DC2626; font-weight:600; margin-top:12px; }

  .mo-nav { display:flex; gap:10px; margin-top:16px; justify-content:flex-end; flex-wrap:wrap; }
  .mo-back-btn { background:#F8FAFC; border:1.5px solid #E2E8F0; border-radius:9px; padding:10px 20px; font-size:13px; font-weight:700; cursor:pointer; color:#64748B; font-family:'Nunito',sans-serif; transition:all 0.18s; }
  .mo-back-btn:hover { border-color:#006D77; color:#006D77; }
  .mo-next-btn, .mo-primary-btn { flex:1; min-width:150px; border:none; border-radius:9px; padding:12px 22px; font-size:14px; font-weight:800; color:#fff; cursor:pointer; font-family:'Nunito',sans-serif; transition:filter 0.2s, transform 0.15s; text-align:center; }
  .mo-next-btn:hover, .mo-primary-btn:hover:not(:disabled) { filter:brightness(1.08); transform:translateY(-1px); }

  /* success */
  .success-wrap { text-align:center; padding:clamp(18px,3.5vw,28px) 20px; position:relative; z-index:1; }
  .success-icon  { font-size:clamp(42px,7vw,58px); margin-bottom:10px; }
  .success-title { font-family:'Sora',sans-serif; font-size:clamp(16px,3vw,21px); font-weight:900; color:#fff; margin-bottom:5px; }
  .success-sub   { font-size:13px; color:rgba(255,255,255,0.8); margin-bottom:14px; }
  .success-ref   { background:rgba(255,255,255,0.15); border-radius:12px; padding:12px 22px; display:inline-block; }
  .success-ref-lbl { font-size:11px; color:rgba(255,255,255,0.65); display:block; margin-bottom:3px; }
  .success-ref-val { font-family:monospace; font-size:clamp(16px,3vw,22px); font-weight:900; color:#80ED99; }
  .success-body  { padding:clamp(14px,3vw,22px) clamp(14px,3.5vw,24px) clamp(16px,3vw,24px); }
  .success-grid  { display:grid; grid-template-columns:repeat(auto-fill, minmax(min(100%,190px), 1fr)); gap:9px; margin-bottom:14px; }
  .success-item  { background:#F8FAFC; border:1px solid #E2E8F0; border-radius:9px; padding:9px 13px; display:flex; flex-direction:column; gap:3px; }
  .si-label      { font-size:10px; font-weight:700; color:#94A3B8; text-transform:uppercase; letter-spacing:0.4px; }
  .si-value      { font-size:13px; font-weight:700; color:#0F172A; }
  .success-note  { font-size:12px; color:#64748B; text-align:center; margin-bottom:14px; line-height:1.6; }

  /* ── Responsive extras ── */
  @media (max-width: 600px) {
    .banner-stat { width:100%; display:flex; align-items:center; gap:10px; padding:10px 14px; }
    .stat-num { font-size:1.8rem; }
    .controls-inner { flex-direction:column; align-items:stretch; }
    .tier-row { overflow-x:auto; flex-wrap:nowrap; padding-bottom:4px; -webkit-overflow-scrolling:touch; }
    .tier-btn { flex-shrink:0; }
    .step-lbl { display:none; }
    .mo-nav { flex-direction:column-reverse; }
    .mo-next-btn, .mo-primary-btn { min-width:unset; }
    .pkg-card-footer { flex-direction:column; align-items:stretch; }
    .pkg-book-btn { width:100%; text-align:center; }
  }
  @media (max-width: 380px) {
    .pay-opt { flex-wrap:wrap; }
    .mo-pkg-pricing { flex-direction:column; align-items:flex-start; }
  }
    .back-button{
  position:absolute;
  top:10px;
  left:20px;
  background:white;
  border-radius:50%;
  padding:8px;
  cursor:pointer;
  box-shadow:0 2px 8px rgba(0,0,0,0.2);
  display:flex;
  align-items:center;
  justify-content:center;
}
`;